import { CartAddEvent, CartErrorEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.addButton = this.querySelector('[data-upsell-add]');
    if (!(this.addButton instanceof HTMLButtonElement)) return;

    this.initialLabel = this.dataset.addLabel || this.addButton.textContent?.trim() || 'Add';
    this.addButton.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    if (!(this.addButton instanceof HTMLButtonElement) || this.addButton.disabled) return;

    const variantId = Number(this.dataset.variantId);
    if (!variantId) return;

    this.addButton.disabled = true;
    this.addButton.textContent = this.dataset.addingLabel || 'Adding...';

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = new Set();

    cartItemsComponents.forEach((component) => {
      if (component instanceof HTMLElement && component.dataset.sectionId) {
        sectionIds.add(component.dataset.sectionId);
      }
    });

    const body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: Array.from(sectionIds).join(','),
      sections_url: window.location.pathname + window.location.search,
    });

    try {
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
      const data = await response.json();

      if (data.status) {
        this.dispatchEvent(
          new CartErrorEvent(
            this.id || `cart-drawer-upsell-${variantId}`,
            data.message,
            data.description,
            data.errors
          )
        );
        this.resetButton();
        return;
      }

      this.addButton.textContent = this.dataset.addedLabel || 'Added';

      this.dispatchEvent(
        new CartAddEvent({}, String(variantId), {
          source: 'cart-drawer-upsell',
          itemCount: 1,
          variantId: String(variantId),
          sections: data.sections,
        })
      );

      window.setTimeout(() => this.resetButton(), 1400);
    } catch (error) {
      console.error(error);
      this.resetButton();
    }
  };

  resetButton() {
    if (!(this.addButton instanceof HTMLButtonElement)) return;
    this.addButton.disabled = false;
    this.addButton.textContent = this.initialLabel;
  }
}

if (!customElements.get('cart-drawer-upsell')) {
  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
